import apiClient from './client';

export interface LoginDto {
  loginIdentifier: string; // email or username
  password: string;
}

export interface AuthUser {
  id: string;
  email: string | null;
  username: string;
  firstName: string | null;
  lastName: string | null;
  role: 'user' | 'admin';
  is_anonymous: boolean;
  isSubscribed: boolean;
  subscribedEnd: Date | null;
}

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  user: AuthUser;
}

export const authApi = {
  /**
   * Логин: бэк выставит httpOnly refresh-cookie, access_token придёт в теле
   * ответа — его кладём в память клиента (см. setAccessToken в client.ts).
   */
  login: async (credentials: LoginDto): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/login', credentials);
    return response.data;
  },

  getCurrentUser: async (): Promise<AuthResponse> => {
    const response = await apiClient.get<AuthResponse>('/auth/me');
    return response.data;
  },

  /**
   * Logout: бэк деактивирует сессию (isActive=false в user_sessions) и
   * чистит refresh-cookie. Ошибки сети глотаем — клиент в любом случае
   * чистит свою память.
   */
  logout: async (): Promise<void> => {
    try {
      await apiClient.post('/auth/logout');
    } catch {
      // ignore
    }
  },
};
